import { useEffect } from 'react';
import { MessageCenterHeader } from '../partials/MessageCenterHeader';
import { MessageCenterList } from '../partials/MessageCenterList';
import { useNotification } from '../services/useNotification';
import classes from './MessageCenterModal.module.scss';

export interface MessageCenterModalProps {
  onCancel: () => void;
}

export const MessageCenterModal = ({ onCancel }: MessageCenterModalProps) => {
  const { loadMessageGroups, serverUnreadMessageCount } = useNotification();

  useEffect(() => {
    loadMessageGroups();
  }, [loadMessageGroups, serverUnreadMessageCount]);

  return (
    <div className={classes.modal}>
      <MessageCenterHeader onCancel={onCancel} />
      <MessageCenterList />
    </div>
  );
};
